Vue.component('DynamicComponent', require('./components/dynamic-component').default);
